export default __webpack_public_path__ + "db40e6164cfe9ed9c82152f4e1e8e1f0.svg";